export const ListQueryKey = 'teamSignConfigs';
export const DetailQueryKey = 'teamSignConfig';

export const Urls = {
  selectUrl: '/groupSignConfig/list',
  updateUrl: '/groupSignConfig/update',
  deleteUrl: '/groupSignConfig/delete',
  createUrl: '/groupSignConfig/create',
  detailUrl: '/groupSignConfig/detail',
};
